import { LOCALES } from 'src/interfaces/i18n.types';

const enLocale: Partial<ILocale> = {
  name: LOCALES.EN,
  weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
    '_',
  ),
  months:
    'January_February_March_April_May_June_July_August_September_October_November_December'.split(
      '_',
    ),
};

export { enLocale };
